import { ActiveScriptCardUnit, PassStep } from '@/models/scripts'
import { ActiveScriptState } from './state'
import { ScriptUnit } from '@/models/scripts'
import { RootState } from '@/store/state'
import _find from 'lodash.find'
import { GetterTree } from 'vuex'

export const getters: GetterTree<ActiveScriptState, RootState> = {
  getActiveScriptId(state): string | undefined {
    return state.scriptId
  },

  getActiveScript(state, getters): ScriptUnit | undefined {
    return getters.getScriptById(state.scriptId)
  },

  hasActiveScript(state): boolean {
    return !!state.scriptId
  },

  getActiveCardStartDate(state): number | undefined {
    return state.started
  },

  getActiveCardNumber(state): number | undefined {
    return state.cardNumber
  },

  getActiveScriptCard(state): ActiveScriptCardUnit | undefined {
    const { cardNumber } = state

    return _find(state?.cards, card => card.num === cardNumber)
  },

  getActiveScriptCards(state): ActiveScriptCardUnit[] | undefined {
    return state.cards
  },

  getActiveScriptHistory(state): PassStep[] | undefined {
    return state.history
  },

  getHistoryStepByCardNum: state => (cardNum: number): PassStep | undefined => {
    return _find(state.history || [], step => step.card === cardNum)
  },
}
